var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17147 11.0454H25.8653C26.1662 11.0454 26.4548 11.1699 26.6676 11.3916C26.8804 11.6132 27 11.9138 27 12.2272C27 12.5407 26.8804 12.8413 26.6676 13.0629C26.4548 13.2845 26.1662 13.409 25.8653 13.409H3.17147C2.87053 13.409 2.58192 13.2845 2.36912 13.0629C2.15633 12.8413 2.03678 12.5407 2.03678 12.2272C2.03678 11.9138 2.15633 11.6132 2.36912 11.3916C2.58192 11.1699 2.87053 11.0454 3.17147 11.0454Z",
    fill: "#8E3B00",
    stroke: "#8E3B00",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87091 12.2273L13.7275 21.5358C13.9506 21.7465 14.076 22.0324 14.076 22.3305C14.076 22.6286 13.9506 22.9145 13.7275 23.1253C13.5043 23.3361 13.2016 23.4545 12.8861 23.4545C12.5705 23.4545 12.2678 23.3361 12.0447 23.1253L1.34914 13.0221C1.23846 12.9178 1.15066 12.7939 1.09075 12.6575C1.03084 12.5211 1 12.3749 1 12.2273C1 12.0796 1.03084 11.9334 1.09075 11.797C1.15066 11.6606 1.23846 11.5368 1.34914 11.4325L12.0447 1.32921C12.2678 1.11842 12.5705 1 12.8861 1C13.2016 1 13.5043 1.11842 13.7275 1.32921C13.9506 1.54 14.076 1.8259 14.076 2.124C14.076 2.42211 13.9506 2.708 13.7275 2.91879L3.87091 12.2273Z",
    fill: "#8E3B00",
    stroke: "#8E3B00",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.70e4e2caa75d570f4fe9e8191dcd51e1.svg";
export { ForwardRef as ReactComponent };